import { useCallback } from 'react'
import styled from 'styled-components'
import useThemeContext from '../../hooks/useThemeContext'
import DarkModeIcon from '../../assests/images/DarkModeIcon.png'
import LightmodeIcon from '../../assests/images/WhiteModeIcon.png'
import Text from 'Tool-kit/Typography'
import MoonIcon from 'assests/icons/MoonIcon'

const Wrapper = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
`

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useThemeContext()

  const toggleHandler = useCallback(
    state => {
      toggleTheme(state)
    },
    [toggleTheme]
  )

  return (
    <Wrapper onClick={() => toggleHandler(!isDark)}>
      <MoonIcon />
      {/* <Text font="popupText" ml="1.2rem" color="themeToggle">
        Dark Mode
      </Text> */}
    </Wrapper>
  )
}

export default ThemeToggle
